module.exports = __webpack_public_path__ + "img/r5-2024.0d428c3f.jpg";